export class QueryUtils {
  static getSearchQuery = (query: string) => {
    if (!query) return new RegExp('(?:)', 'i');
    return new RegExp(query.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1') + '(?=[^>]*<|(?:[^<>"\']*$))', 'i');
  };
}
